import { IPromotionDetailsProps } from './PromotionDetail.types'
import {
  PromotionDetailWrapper,
  PromotionImage
} from './PromotionDetail.styles'
import { isString } from '../../../utils'
import PromotionLabel from '../PromotionLabel'
import useId from '../../hooks/useId'

const PromotionDetail = ({
  text,
  image = '',
  type = 'detail',
  icon,
  showIcon = false,
  color = 'background.default',
  styles,
  'data-testid': testid = 'promotion-detail',
  secondaryText = '',
  wrap = false,
  size = '1em',
  title,
  ...props
}: IPromotionDetailsProps) => {
  const { getTestId } = useId(testid)
  const imageProps = isString(image) ? { src: image } : image
  const isValidImage =
    (isString(image) && image.length > 0) || Object.keys(image).length > 0
  const showImage = isValidImage && type !== 'detail-extended'

  return (
    <PromotionDetailWrapper
      sx={styles}
      hasImage={isValidImage}
      color={color}
      data-testid={getTestId()}
      type={type}
      {...props}>
      {showImage && (
        <PromotionImage data-testid={getTestId('image')} {...imageProps} />
      )}
      <PromotionLabel
        icon={icon}
        showIcon={showIcon}
        type={type}
        text={text}
        wrap={wrap}
        size={size}
        title={title}
        secondaryText={secondaryText}
        {...props}
        data-testid={getTestId('label')}
      />
    </PromotionDetailWrapper>
  )
}

export default PromotionDetail
